var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',{class:_vm.$style.title},[_vm._v("\n    404\n    "),(_vm.resource)?[_vm._v("\n      "+_vm._s(_vm.resource)+"\n    ")]:_vm._e(),_vm._v("\n    Not Found\n  ")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }